import local from './local.mjs';
import development from "./development.mjs";
import demo from "./demo.mjs";
import production from "./production.mjs";
import atomy from "./atomy.mjs";
import kbDevelopment from "./kbDevelopment.mjs";
import kbStage from "./kbStage.mjs";
import kbProduction from "./kbProduction.mjs";
import kpopFactoryProduction from "./kpopFactoryProduction.mjs";

function getEnvironment() {
    const environment = process.env.REACT_APP_NOT_SECRET_CODE;
    if(!environment)
        return environment;
    return environment.trim();
}

function _getConfig(stage) {
    switch(stage) {
        case "production" :
            return production;
        case "demo" :
            return demo;
        case "development" :
            return development;
        case "atomy" :
            return atomy;
        case "kb_development" :
            return kbDevelopment;
        case "kb_stage" :
            return kbStage;
        case "kb_production" :
            return kbProduction;
        case "kpop_factory_production":
            return kpopFactoryProduction;

    }

    return local;
};

function getConfig(stage) {
    const targetStage = stage ? stage : getEnvironment();
    return _getConfig(targetStage);
};

export default getConfig;